"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapPageElement = void 0;

var _react = _interopRequireDefault(require("react"));

var _indicator = _interopRequireDefault(require("./indicator"));

const wrapPageElement = ({
  element
}) => {
  if (process.env.GATSBY_PREVIEW_INDICATOR_ENABLED === `true`) {
    return /*#__PURE__*/_react.default.createElement(_indicator.default, null, element);
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, element);
  }
};

exports.wrapPageElement = wrapPageElement;